<template>
  <div class="w-full h-screen bg-darkBlue">
    <el-row class="tac">
      <el-col :span="24">
        <el-menu
          default-active="home"
          class="el-menu-vertical-demo"
          background-color="#13499B"
          text-color="#fff"
          active-text-color="#ffd04b"
        >
          <el-menu-item index="home" @click="handleNavigateToHome">
            <span slot="title">首页</span>
          </el-menu-item>
          <template v-for="item in menuList">
            <el-submenu
              :index="item?.id"
              v-if="item?.children instanceof Array"
              :key="item?.id"
            >
              <span slot="title">{{ item.text }}</span>
              <el-menu-item
                @click="() => handlenavigateToPage(child?.id,item?.text)"
                v-for="child in item?.children"
                :index="child?.id"
                :key="child?.id"
              >
                <span slot="title">{{ child?.text }}</span>
              </el-menu-item>
            </el-submenu>
            <el-menu-item
              @click="() => handlenavigateToPage(item?.id,item?.text)"
              :index="item?.id"
              :key="item?.id + '_else'"
              v-else
            >
              <span slot="title">{{ item?.text }}</span>
            </el-menu-item>
          </template>
          <template>
            <el-submenu v-if="$store.state.isLogin">
              <span slot="title">开放预约</span>
              <el-menu-item
                @click="() => gotoApply()">
                <span slot="title">实验室预约</span>
              </el-menu-item>
              <el-menu-item
                @click="() => gotoMyApply()">
                <span slot="title">我的预约</span>
              </el-menu-item>
            </el-submenu>

          </template>
        </el-menu>
      </el-col>
    </el-row>
    <div
      v-if="!$store.state.isLogin"
      class="w-full px-5 pt-3 pb-10 bg-darkBlue"
      @click="handleNavigateToLogin"
    >
      <el-button class="w-full font-bold text-base text-darkBlue tracking-wider"
        >登&nbsp;&nbsp;录</el-button
      >
    </div>
    <div
      v-else
      class="w-full px-5 pt-3 pb-10 bg-darkBlue"
    >
      <el-button class="w-full font-bold text-base text-darkBlue tracking-wider"
        ><a style="display:block"
                :href="
                  '/mainsys/cmsapi/logout.do?siteName=' + siteInfo.siteName
                "
                >退出登录</a>
      </el-button>
    </div>
  </div>
</template>

<script>
import { getSiteFirstMenu } from "../api/header";
import { getMobileHeaderList } from "../utils/formatResData";
import mixins from "../hooks";
export default {
  mixins: [mixins],
  data() {
    return {
      menuList: [],
    };
  },
  methods: {
    // 获取菜单列表
    async handleGetMenuList() {
      const res = await getSiteFirstMenu();
      this.menuList = getMobileHeaderList(res);
      // if(this.$store.state.isLogin){
      //   let applyData={
      //     text:'开放预约',
      //     children
      //   }
      // }
      // console.log(this.menuList,'menList')
    },
    // 跳转登录页
    handleNavigateToLogin() {
      this.$emit("setIsMenuVisible");
      this.$router.push({
        path: "/mobileLogin",
        name: "mobileLogin",
      });
    },

    // 跳转页面
    handlenavigateToPage(id,name) {
      console.log('跳转sssssssssssss',id,name)
      this.$emit("setIsMenuVisible");
      if (name == "教学资源") {
        this.$router.push({
          path: "ListTeach:menuId",
          name: "ListTeach",
          params: { menuId: id },
        });
      } else {
        this.$router.push({
          path: "List:menuId",
          name: "List",
          params: { menuId: id },
        });
      }
    },
    gotoApply(){
      this.$emit("setIsMenuVisible");
      this.$router.push({
        path: "/collegeList",
      });
    },
    gotoMyApply(){
      this.$emit("setIsMenuVisible");
      this.$router.push({
        path: "/myApply",
      });
    },
    // 跳转首页
    handleNavigateToHome() {
      this.$emit("setIsMenuVisible");
      this.$router.push({
        path: "/",
      });
    },
  },

  created() {
    this.handleGetMenuList();
  },
};
</script>
